module.exports = __webpack_public_path__ + "img/katapukt_screen_mobile.3d665bc.svg";